module.exports = __webpack_public_path__ + "static/media/logo.ffe99d87.svg";